<template>
  <div class='TooltipText' :style="style">{{data.controls.textTitle}}</div>
</template>

<script>
export default {
  name: 'TooltipText',

  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  computed: {
    style () {
      return {
        color: this.data.controls.textColor,
        fontSize: `${parseInt(this.data.controls.textSize) / 192}rem`,
        fontWeight: this.data.controls.textWeight,
        textAlign: this.data.controls.textLocation
      }
    }
  }
}
</script>
